// Navigazione dell'applicazione, per ruolo. `perm` indica la sezione
// soggetta a permessi granulari per gli operatori.
export const STUDIO_NAV = [
  { key: "dashboard", label: "Dashboard", icon: "LayoutDashboard", path: "/app/dashboard", perm: null, ready: true },
  { key: "agenda", label: "Agenda", icon: "CalendarDays", path: "/app/agenda", perm: null, ready: true },
  { key: "pratiche", label: "Gestione Pratiche", icon: "FolderKanban", path: "/app/pratiche", perm: "pratiche", ready: true },
  { key: "archivio", label: "Archivio Pratiche", icon: "Archive", path: "/app/archivio", perm: "pratiche", ready: true },
  { key: "anagrafiche", label: "Anagrafiche", icon: "Contact", path: "/app/anagrafiche", perm: "anagrafiche", ready: true },
  { key: "lettere", label: "Gestione Lettere", icon: "FileText", path: "/app/lettere", perm: "lettere", ready: true },
  { key: "allegati-studio", label: "Allegati Studio", icon: "Paperclip", path: "/app/allegati-studio", perm: "allegati_studio", ready: true },
  { key: "email", label: "Email", icon: "Mail", path: "/app/email", perm: null, ready: true },
  { key: "pec", label: "PEC", icon: "ShieldCheck", path: "/app/pec", perm: null, ready: true },
  { key: "messaggi", label: "Messaggistica", icon: "MessageSquare", path: "/app/messaggi", perm: "messaggi", ready: true },
  { key: "messaggi-segnalatori", label: "Messaggi segnalatori", icon: "MessagesSquare", path: "/app/messaggi-segnalatori", perm: "messaggi", ready: true },
  { key: "rubrica", label: "Rubrica", icon: "BookUser", path: "/app/rubrica", perm: "rubrica", ready: true },
  { key: "contabilita", label: "Contabilità", icon: "Euro", path: "/app/contabilita", perm: "contabilita", ready: true },
  { key: "riepilogo-segnalatori", label: "Riepilogo Segnalatori", icon: "Users", path: "/app/riepilogo-segnalatori", perm: "contabilita", ready: true },
  { key: "proforme", label: "Fatture Proforma", icon: "FileText", path: "/app/proforme", perm: "contabilita", ready: true },
  { key: "cestino", label: "Cestino", icon: "Trash2", path: "/app/cestino", perm: null, ownerOnly: true, ready: true },
  { key: "privacy", label: "Privacy GDPR", icon: "ShieldCheck", path: "/app/privacy", perm: null, ownerOnly: true, ready: true },
  {
    key: "impostazioni",
    label: "Impostazioni Studio",
    icon: "Settings",
    path: "/app/impostazioni",
    perm: null,
    ownerOnly: true,
    ready: true,
    children: [
      { key: "dati-studio", label: "Dati Studio", to: "/app/impostazioni#sez-dati-studio" },
      { key: "conti-correnti", label: "Conti Correnti", to: "/app/impostazioni#sez-conti-correnti" },
      { key: "utenti", label: "Utenti e Permessi", to: "/app/operatori" },
      { key: "email", label: "Configurazione Email", to: "/app/impostazioni#sez-email" },
      { key: "pec", label: "Configurazione PEC", to: "/app/impostazioni#sez-pec" },
      { key: "whatsapp", label: "Messaggi WhatsApp", to: "/app/impostazioni#sez-whatsapp" },
      { key: "frasario", label: "Frasario Diario", to: "/app/impostazioni#sez-frasario" },
      { key: "dinamiche", label: "Gestione Dinamiche Sinistro", to: "/app/impostazioni#sez-dinamiche" },
      { key: "campi-obbligatori", label: "Campi Obbligatori Pratica", to: "/app/impostazioni#sez-campi-obbligatori" },
      { key: "stati-aggiuntivi", label: "Stati Aggiuntivi", to: "/app/impostazioni#sez-stati-aggiuntivi" },
      { key: "tipologie-sinistro", label: "Tipologie Sinistro", to: "/app/impostazioni#sez-tipologie-sinistro" },
      { key: "campi-copertina", label: "Campi Copertina Pratica", to: "/app/impostazioni#sez-campi-copertina" },
      { key: "modelli", label: "Modelli Lettera e Cartelle", to: "/app/lettere" },
      { key: "tariffe", label: "Tariffe e Onorari", to: "/app/impostazioni#sez-tariffe" },
      { key: "fatturazione", label: "Impostazioni Fatturazione", to: "/app/impostazioni#sez-fatturazione" },
      { key: "bookmarklet-aruba", label: "Bookmarklet Aruba", to: "/app/bookmarklet-aruba" },
      { key: "assistenza-remota", label: "Assistenza Remota", action: "remote-support" },
      { key: "abbonamento", label: "Abbonamento", to: "/app/impostazioni#sez-abbonamento" },
      { key: "area-cliente", label: "Personalizzazione Area Riservata Cliente", to: "/app/impostazioni#sez-area-cliente" },
      { key: "impexp", label: "Import / Export & Backup", to: "/app/impexp" },
    ],
  },
];

export const ADMIN_NAV = [
  { key: "dashboard", label: "Dashboard", icon: "LayoutDashboard", path: "/admin/dashboard", ready: true },
  { key: "studi", label: "Gestione Studi", icon: "Building2", path: "/admin/studi", ready: true },
  { key: "richieste-rinnovo", label: "Richieste Rinnovo", icon: "BellRing", path: "/admin/richieste-rinnovo", ready: true },
  { key: "compagnie-master", label: "Compagnie Master", icon: "Building", path: "/admin/compagnie-master", ready: true },
  { key: "richieste-compagnie", label: "Richieste Compagnie", icon: "Inbox", path: "/admin/richieste-compagnie", ready: true },
  { key: "storage", label: "Storage Globale", icon: "HardDrive", path: "/admin/storage", ready: true },
  { key: "impostazioni-allegati", label: "Impostazioni allegati", icon: "Paperclip", path: "/admin/impostazioni-allegati", ready: true },
  { key: "branding", label: "Favicon & Icone", icon: "Image", path: "/admin/branding", ready: true },
  { key: "email", label: "Impostazioni Email", icon: "Mail", path: "/admin/email", ready: true },
  { key: "assistenza-remota", label: "Assistenza Remota", icon: "LifeBuoy", path: "/admin/assistenza-remota", ready: true },
  { key: "sito-web", label: "Sito Web", icon: "Globe", path: "/admin/sito-web", ready: true },
  { key: "importazione", label: "Importazione Dati", icon: "Database", path: "/admin/importazione", ready: true },
  { key: "manutenzione", label: "Manutenzione", icon: "Wrench", path: "/admin/manutenzione", ready: true },
  { key: "gdpr", label: "Privacy e GDPR", icon: "ShieldCheck", path: "/admin/gdpr", ready: true },
  { key: "impexp", label: "Import / Export & Backup", icon: "DatabaseBackup", path: "/app/impexp", ready: true },
  { key: "cestino", label: "Cestino", icon: "Trash2", path: "/app/cestino", ready: true },
];

export const CLIENTE_NAV = [
  { key: "overview", label: "Area Riservata", icon: "LayoutDashboard", path: "/area/overview", ready: true },
  { key: "pratiche", label: "Le Mie Pratiche", icon: "FolderKanban", path: "/area/pratiche", ready: true },
  { key: "documenti", label: "Documenti", icon: "FileArchive", path: "/area/documenti", ready: false },
  { key: "messaggi", label: "Messaggi allo Studio", icon: "MessageSquare", path: "/area/messaggi", ready: true },
];

export const ROLE_LABELS = {
  superadmin: "Superadmin",
  titolare: "Titolare Studio",
  amministratore: "Amministratore",
  operatore: "Operatore",
  cliente: "Cliente",
};

// Variabili segnaposto disponibili nei template lettere.
export const PLACEHOLDER_VARS = [
  "{{nome_assistito}}", "{{numero_pratica}}", "{{data_sinistro}}",
  "{{targa}}", "{{compagnia}}", "{{codice_fiscale}}", "{{importo_risarcimento}}",
];
